import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar-nav ml-auto" }

export function render(_ctx, _cache) {
  const _component_menu_header = _resolveComponent("menu-header")
  const _component_user_logout = _resolveComponent("user-logout")

  return (_openBlock(), _createElementBlock("nav", {
    id: "main-header",
    class: _normalizeClass(["main-header navbar navbar-expand", _ctx.navbarVariant])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("ul", { class: "navbar-nav" }, [
      _createElementVNode("h4", null, [
        _createElementVNode("b", null, "HIAE"),
        _createTextVNode(" TRAUMA")
      ])
    ], -1)),
    _createElementVNode("ul", _hoisted_1, [
      (_ctx.isMasterUser)
        ? (_openBlock(), _createBlock(_component_menu_header, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_user_logout)
    ])
  ], 2))
}